import { render, staticRenderFns } from "./imgShow.vue?vue&type=template&id=70971309&scoped=true"
import script from "./imgShow.vue?vue&type=script&lang=js"
export * from "./imgShow.vue?vue&type=script&lang=js"
import style0 from "./imgShow.vue?vue&type=style&index=0&id=70971309&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70971309",
  null
  
)

export default component.exports